

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //webApiUrl: 'https://localhost:44301/',
  webApiUrl: 'https://creditcoachdevelopmentwebapi.azurewebsites.net/',
  // webApiUrl: 'https://app-scs-api-test-001.azurewebsites.net/',
  encryptionKey: 'b14ca5898a4e4133bbce2ea2315a2000',
  sessionTimeOut: 60 * 5,
  otpPolicy: {
    firstOtpExpiryMinutes: 3,
    sessionLifespanMinutes: 6,
    resendAfterSeconds: 30
  },
  enableServiceWorker: false,
  enableStitchRemoveButton: false,
  appInsights: {
    isEnable: true,
    instrumentationKey: '11bee8dc-6c5e-49f7-98ed-22f7cea6cdc0'
  },
  freshChatToken: '0b79cb57-b3c7-41ed-8755-d30ead5c603c',
  freshChatHost: 'https://wchat.eu.freshchat.com',
  acceptSPLTcUrl: 'https://preprod.sanlamloanapplication.co.za/turbo/b/terms',
  azureAdConfig: {
    b2cDomain: 'b2clogin.com',
    tenant:'idmcc.b2clogin.com',
    discoveryDocumentConfig: {
      url: 'https://idmcc.b2clogin.com/tfp/idmcc.onmicrosoft.com/B2C_1_cc/v2.0/.well-known/openid-configuration'
    },
    authConfig: {
      redirectUri: window.location.origin + '/portal/home',
      postLogoutRedirectUri: window.location.origin + '/login',
      responseType: 'token id_token',
      issuer: 'https://idmcc.b2clogin.com/tfp/b6336d91-19ac-4844-9585-f53f71498c49/b2c_1_cc/v2.0/',
      strictDiscoveryDocumentValidation: false,
      tokenEndpoint: 'https://idmcc.b2clogin.com/idmcc.onmicrosoft.com/b2c_1_cc/oauth2/v2.0/token',
      loginUrl: 'https://idmcc.b2clogin.com/idmcc.onmicrosoft.com/b2c_1_cc/oauth2/v2.0/authorize',
      clientId: '7fe6a037-8e9d-41d4-9e4e-cce5960a5f40',
      scope: 'openid profile https://idmcc.onmicrosoft.com/ccapi/user_impersonation',
      skipIssuerCheck: true,
      clearHashAfterLogin: true,
      oidc: true,
      logOutUrl: 'https://idmcc.b2clogin.com/idmcc.onmicrosoft.com/b2c_1_cc/oauth2/v2.0/logout?post_logout_redirect_uri='
    }
  },
  // utm_campaign values (case-insensitive) that go through the Sanlam Online journey; everyone else uses SCS.
  solUtmCampaigns: ['g', 'g1', 'g2', 'legacy'],
  // Sanlam Online federated B2C - used by /scs-consent. azureAdConfig below is the normal SCS B2C.
  solAzureAdConfig: {
    b2cDomain: 'b2clogin.com',
    tenant:'idmcc.b2clogin.com',
    discoveryDocumentConfig: {
      url: 'https://idmcc.b2clogin.com/tfp/idmcc.onmicrosoft.com/B2C_1A_SANLAM_FEDERATED_SIGNIN/v2.0/.well-known/openid-configuration'
    },
    authConfig: {
      redirectUri: window.location.origin + '/scs-consent',
      postLogoutRedirectUri: window.location.origin + '/login',
      responseType: 'token id_token',
      issuer: 'https://idmcc.b2clogin.com/tfp/b6336d91-19ac-4844-9585-f53f71498c49/B2C_1A_SANLAM_FEDERATED_SIGNIN/v2.0/',
      strictDiscoveryDocumentValidation: false,
      tokenEndpoint: 'https://idmcc.b2clogin.com/idmcc.onmicrosoft.com/B2C_1A_SANLAM_FEDERATED_SIGNIN/oauth2/v2.0/token',
      loginUrl: 'https://idmcc.b2clogin.com/idmcc.onmicrosoft.com/B2C_1A_SANLAM_FEDERATED_SIGNIN/oauth2/v2.0/authorize',
      //loginUrl: 'https://idmcc.b2clogin.com/idmcc.onmicrosoft.com/b2c_1_cc/oauth2/v2.0/token',

      clientId: '7fe6a037-8e9d-41d4-9e4e-cce5960a5f40',
      scope: 'openid profile https://idmcc.onmicrosoft.com/ccapi/user_impersonation',
      skipIssuerCheck: true,
      clearHashAfterLogin: true,
      oidc: true,
      logOutUrl: 'https://idmcc.b2clogin.com/idmcc.onmicrosoft.com/B2C_1A_SANLAM_FEDERATED_SIGNIN/oauth2/v2.0/logout?post_logout_redirect_uri='
    }
  },

  sanlamPortfolioUrl: 'https://cp-tst.sanlam.co.za',
  activateBudgetOnDashBoard:false,
  enableStitchOnBudget:true,
  activateLESPersonalLoanButton:false,
  enableCreditConsolidation: true,
  displayWealthScore: true,
  yodleeConfig:{
    fastLinkUrl:"https://finapp.sanlamstage.yodlee.com/authenticate/sanlam/fastlink/",
    configName:"Demo"
  },
  essentialMEDConfig:{
    linkUrl:"https://episodic-website-2023.webflow.io/lp/scs/hi",
  },
  trackingUrl:"https://devtrc.digitechlab.co.za/lib/minified-js/tracking-lib.js",
  trackingId:"001",
  financeURL:"https://finance.f27.me/",
  scsTermsUrl:"https://preprod.sanlamloanapplication.co.za/turbo/b/termsSCS",
  returnXPostbackBaseUrl:"https://tracking.affcoza.com/aff_c",
  solRegistrationUrl: "https://www-pre-tst.sanlamonline.co.za",
  solLogoutUrl: "https://www-pre-tst.sanlamonline.co.za/personal/credit-solutions/credit-profile-test",
  solIdpLogoutUrl: "https://login-tst.sanlamonline.co.za/8b1e926d-0de4-418f-baaf-f947804a6b69/b2c_1a_sanlam_public_signin/oauth2/v2.0/logout",
  preproduction:false,
  GeminiSetup: {  
  IsGeminiEnable: "true",
  SplCallThresold: "500"
},
  enableCellVerificationPopup: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
